import { useState } from "react";
import { Check, Link as LinkIcon } from "lucide-react";
import { toast } from "sonner";

// A tiny button that copies a share-able link to the clipboard.
// Falls back to a textarea select+copy when the Clipboard API isn't available
// (e.g. on insecure contexts or older browsers).
export default function CopyInviteButton({
  url,
  label = "Copy invite",
  copiedLabel = "Copied",
  className = "",
  testId,
  toastMessage,
}) {
  const [copied, setCopied] = useState(false);

  const copy = async (e) => {
    e?.preventDefault();
    e?.stopPropagation();
    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
      } else {
        const ta = document.createElement("textarea");
        ta.value = url;
        ta.setAttribute("readonly", "");
        ta.style.position = "fixed";
        ta.style.opacity = "0";
        document.body.appendChild(ta);
        ta.select();
        document.execCommand("copy");
        document.body.removeChild(ta);
      }
      setCopied(true);
      if (toastMessage !== false) {
        toast.success(toastMessage || "Invite link copied — share it anywhere");
      }
      setTimeout(() => setCopied(false), 2200);
    } catch {
      toast.error("Couldn't copy — long-press the link instead");
    }
  };

  return (
    <button
      type="button"
      onClick={copy}
      data-testid={testId}
      className={
        className ||
        "inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full border border-jj bg-cream-surface text-jjblue hover:border-gold transition-colors"
      }
      aria-label={copied ? copiedLabel : label}
    >
      {copied ? <Check className="h-3.5 w-3.5 text-burgundy" /> : <LinkIcon className="h-3.5 w-3.5" />}
      <span>{copied ? copiedLabel : label}</span>
    </button>
  );
}
